import { colors } from '@flowwai-frontend/shared/style-guide'

const pmuPortalTheme = {
   light: {
      pmuUserHeader: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         refreshIconColor: '!bg-base-white'
      },
      pmuUserBody: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         settingCardTitleColor: 'text-gray-800',
         userNameCardBgColor: 'bg-gray-50',
         labelColor: 'text-gray-500',
         descriptionColor: 'text-gray-600',
         userIconColorBg: 'bg-gray-100',
         alertIconFillColor: colors['error-100'],
         alertIconStrokeColor: colors['error-50'],
         textColor: 'text-gray-700',
         baseWhiteColor: 'bg-base-white',
         createOfficerCard: {
            iconBgColor: 'bg-primary-200',
            iconColor: colors['primary-600'],
            titleColor: 'text-gray-800'
         },
         notifyUserModal: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            userIconColorBg: 'bg-primary-100'
         },
         assignMandal: {
            checkIconColor: colors['base-white'],
            checkboxSelectedBgColor: 'bg-primary-600',
            checkboxSelectedBorderColor: 'border-primary-600',
            defaultBorderColor: 'border-gray-300',
            labelColor: 'text-gray-600'
         }
      },
      pmuUserLogs: {
         bgColor: 'bg-gray-100',
         pmuUserLogsHeader: {
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900',
            refreshIconColor: '!bg-base-white',
            closeIconColor: colors['gray-500'],
            filterButtonStyle: 'border-primary-600'
         },
         filterConditionPills: {
            borderColor: 'border-gray-300',
            iconColors: colors['primary-600'],
            propertyIconColor: colors['primary-600'],
            tooltipArrowColor: colors['gray-900'],
            addFilterButton: {
               iconColor: colors['primary-600'],
               textColor: 'text-primary-700',
               borderColor: 'border-primary-600'
            },
            clearFilterButton: {
               iconColor: colors['gray-600'],
               textColor: 'text-gray-600'
            }
         },
         pmuUserLogCard: {
            dividerColor: 'border-gray-200',
            titleColor: 'text-gray-900',
            textColor: 'text-gray-800',
            labelColor: 'text-gray-600',
            reasonTextColor: 'text-gray-800',
            phoneNumberIconColor: colors['primary-600'],
            baseWhiteColor: 'bg-base-white',
            defaultBorderColor: 'border-gray-300',
            transferUserCard: {
               iconBgColor: 'bg-lime-200',
               iconColor: colors['lime-700']
            },
            deactivateUserCard: {
               iconBgColor: 'bg-red-200',
               iconColor: colors['red-700']
            },
            userDetailsUpdateCard: {
               iconBgColor: 'bg-primary-200',
               iconColor: colors['primary-500']
            },
            userLeaveCard: {
               leaveStartIconBgColor: 'bg-purple-200',
               leaveStartIconColor: colors['purple-600'],
               leaveEndIconBgColor: 'bg-warning-200',
               leaveEndIconColor: colors['warning-600'],
               iconBgColor: 'bg-warning-500',
               iconColor: colors['base-white']
            }
         }
      }
   },
   dark: {}
}

export default pmuPortalTheme
